export default "__VITE_ASSET__ec3b23aa__"